export default function createThrottler(initOptions = { delay: 2000 }) {
  const { delay } = initOptions;

  let pendingItem;
  let nextDueAt;

  return function throttler(fnToThrottle) {
    throttler.clear = () => {
      if (pendingItem) clearTimeout(pendingItem);
      pendingItem = undefined;
    };

    const now = new Date().getTime();
    if (!nextDueAt || (nextDueAt < now && !pendingItem)) {
      nextDueAt = new Date().getTime() + delay;
      fnToThrottle();
      return;
    }

    if (pendingItem) clearTimeout(pendingItem);
    pendingItem = setTimeout(() => {
      nextDueAt = new Date().getTime() + delay;
      fnToThrottle();
      pendingItem = undefined;
    }, nextDueAt - now);
  };
}
